<template>
  <div class="native-table-wrap">
    <table class="native-table">
      <thead>
        <tr>
          <th>ID</th><th>科室名称</th><th>分类</th><th>科主任</th>
          <th>首页科室介绍</th><th>科室介绍简要</th><th>科室详情</th>
          <th>重点科室介绍</th><th>操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in departmentList" :key="row.id">
          <td>{{ row.id }}</td><td>{{ row.name }}</td><td>{{ row.category }}</td>
          <td>{{ row.director }}</td><td class="truncate" :title="row.descmain">{{ row.descmain }}</td>
          <td class="truncate" :title="row.description">{{ row.description }}</td>
          <td class="truncate" :title="row.introduce">{{ row.introduce }}</td>
          <td class="truncate" :title="row.descimp">{{ row.descimp }}</td>
          <td class="actions">
            <NativeButton type="primary" size="small" @click="emit('edit', row)">编辑</NativeButton>
            <NativeButton type="danger" size="small" @click="emit('delete', row)">删除</NativeButton>
          </td>
        </tr>
        <tr v-if="departmentList.length === 0"><td colspan="9" class="empty-cell">暂无数据</td></tr>
      </tbody>
    </table>
  </div>
</template>

<script lang="ts" setup>
import type { DepartmentType } from "@/stores/departments";

defineProps<{ departmentList: DepartmentType[] }>();
const emit = defineEmits<{
  (event: "edit", row: DepartmentType): void;
  (event: "delete", row: DepartmentType): void;
}>();
</script>

<style scoped>
.native-table-wrap { min-width: 0; overflow: auto; }
.native-table { width: 100%; border-collapse: collapse; font-size: 0.9rem; }
th, td { padding: 10px 12px; border: 1px solid #e2e8f0; text-align: left; vertical-align: top; }
th { position: sticky; top: 0; background: #f8fafc; color: #334155; white-space: nowrap; }
tbody tr:nth-child(even) { background: #fafafa; }
.truncate { max-width: 180px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.actions { display: flex; gap: 6px; }
.empty-cell { padding: 30px; color: #64748b; text-align: center; }
</style>
